import { uniqueId } from 'lodash-es';
import { default as React, useState, type FC, type PropsWithChildren } from 'react';
import { Toast } from 'react-bootstrap';

import styles from './GlobalMessages.module.scss';
import { GlobalMessagesContext, type Message } from './GlobalMessagesContext';

interface GlobalMessage extends Message {
  id: string;
}

type SetGlobalMessage = (value: ((prevState: GlobalMessage[]) => GlobalMessage[]) | GlobalMessage[]) => void;

const buildTriggerMessage = (setMessages: SetGlobalMessage) => (message: Message) => {
  setMessages((messages) => [
    ...messages,
    {
      ...message,
      id: uniqueId('globalMessage'),
    },
  ]);
};

const buildCloseMessage = (setMessages: SetGlobalMessage, messageId: string) => () => {
  setMessages((messages) => messages.filter((message) => message.id !== messageId));
};

export const GlobalMessages: FC = ({ children }: PropsWithChildren<object>) => {
  const [messages, setMessages] = useState<GlobalMessage[]>([]);

  const triggerMessage = buildTriggerMessage(setMessages);

  return (
    <GlobalMessagesContext.Provider value={{ triggerMessage }}>
      {messages.length > 0 && (
        <div className={styles.container}>
          {messages.map((message) => (
            <Toast key={message.id} className={styles.toast} onClose={buildCloseMessage(setMessages, message.id)}>
              <Toast.Header>
                <strong className="mr-auto">{message.title}</strong>
              </Toast.Header>
              <Toast.Body>{message.body}</Toast.Body>
            </Toast>
          ))}
        </div>
      )}
      {children}
    </GlobalMessagesContext.Provider>
  );
};
